// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'POS cash withdrawal'"></sub-header>

    <h2 class="section-header">POS cash withdrawal</h2>
    <form name="\$ctrl.transactionForm">

      <div class="alert" ng-if="!\$ctrl.branch.posSupport">
        Warning! POS transactions are not allowed in this branch. Please check branch configuration.
      </div>

      <table class="misc-transaction__table table">
        <tbody>
        <tr>
          <td>1.</td>
          <td>Amount:</td>
          <td>
            <cash ng-required="true"
                  ng-disabled="!\$ctrl.branch.posSupport"
                  ng-model="\$ctrl.transaction.amount"
                  min="0.01">
            </cash>
          </td>
        </tr>
        <tr>
          <td>2.</td>
          <td>Remarks:</td>
          <td>
            <input
              type="text"
              required
              ng-disabled="!\$ctrl.branch.posSupport"
              maxlength="512"
              ng-model="\$ctrl.transaction.remarks"/>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button
          class="misc-transaction__cancel btn btn-warning"
          type="button"
          ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
          class="misc-transaction__save btn btn-primary"
          type="button"
          ng-disabled="!\$ctrl.branch.posSupport || \$ctrl.transactionForm.\$invalid"
          ng-click="\$ctrl.save()">
          Transfer now
        </button>
      </div>

    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/pos-cash-withdrawal/pos-cash-withdrawal.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;